import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export interface UnlockChatDialogData {
  staffDetails: { clinician: { id: number; firstname: string; lastname: string }; age: number; timeout: number };
  patientDetails: { firstname: string; lastname: string; state: string };
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'messaging-unlock-chat-dialog',
  standalone: true,
  templateUrl: './unlock-chat-dialog.component.html',
  styleUrls: [
    '../../../../../../ui-components/src/lib/_styles/abstracts/_colors.scss',
    '../../../../../../ui-components/src/lib/_styles/abstracts/_typography.scss',
    '../../../../../../ui-components/src/lib/_styles/abstracts/_spacing.scss',
    './unlock-chat-dialog.component.scss',
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class UnlockChatDialogComponent {
  private readonly dialogRef = inject(DialogRef<boolean>);
  protected readonly data = inject<UnlockChatDialogData>(DIALOG_DATA);

  protected readonly clinicianName = `${this.data.staffDetails.clinician.firstname} ${this.data.staffDetails.clinician.lastname}`;
  protected readonly patientName = `${this.data.patientDetails.firstname} ${this.data.patientDetails.lastname} - ${this.data.patientDetails.state}`;
  protected readonly minutesAgo = Math.floor(this.data.staffDetails.age / 60);
  protected readonly secondsAgo = this.data.staffDetails.age - this.minutesAgo * 60;
  protected readonly expireMinutes = Math.floor((this.data.staffDetails.timeout - this.data.staffDetails.age) / 60);
  protected readonly expireSeconds =
    this.data.staffDetails.timeout - this.data.staffDetails.age - this.expireMinutes * 60;

  close() {
    this.dialogRef.close(false);
  }

  unlock() {
    this.dialogRef.close(true);
  }
}
